import { FC, PropsWithChildren, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { dashboardTabs } from 'src/modules/user/constants/dashboardTabs'
import { parseDashboardTabIndexFromSearchParams } from 'src/modules/user/constants/dashboard-tab-navigation'
import { TabContext } from './tab-context'

export const TabProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [searchParams] = useSearchParams()
  const [currentTabIndex, setCurrentTabIndex] = useState(() =>
    parseDashboardTabIndexFromSearchParams(searchParams, dashboardTabs.length),
  )
  const [prevTabIndex, setPrevTabIndex] = useState(0)

  return (
    <TabContext.Provider
      value={{
        currentTabIndex,
        setCurrentTabIndex,
        prevTabIndex,
        setPrevTabIndex,
      }}
    >
      {children}
    </TabContext.Provider>
  )
}
